import { useTranslation } from "react-i18next";

export default function useDistributionChannelPipelinesTableColumns() {
	const { t } = useTranslation();

	return [
		{
			id: "name",
			filter: "text",
			disableSortBy: true,
			Header: t("Name", "Name"),
		},
	];
}
